import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import CMSService from "@/services/CMSService.js";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic,
            pageTitle: "",
            pageContent: ""
        };
    },
    metaInfo() {
        return {
            title: `Cookie Policy`,
            meta: [
                {
                    name: "description",
                    content: `YourDictionary.com's Cookie Policy.`
                }
            ]
        };
    },
    methods: {
        fetchContent() {
            CMSService.getCookiePolicy().then(
                response => {
                    const data = response.data.data;
                    this.pageTitle = data.title;
                    this.pageContent = data.body;
                },
                err => {
                    this.status.err = true;
                }
            );
        }
    },
    mounted() {
        this.fetchContent();
    }
};



// WEBPACK FOOTER //
// ./src/pages/CookiePolicy/CookiePolicy.js